import { CurrentUser } from "@workspace/types";
import { clientFetcher } from "./client-fetcher";

export const getCurrentUser = async (): Promise<CurrentUser> => {
  return (await clientFetcher.get("/users/me")).data;
};

export const updateActiveWorkspace = async (
  workspaceId: string,
): Promise<void> => {
  await clientFetcher.put("/users/me/active-workspace", {
    workspace_id: workspaceId,
  });
};

export const deleteCurrentUser =
  !process.env.NEXT_PUBLIC_CONFIGURATION ||
  process.env.NEXT_PUBLIC_CONFIGURATION === "staging"
    ? async (): Promise<void> => {
        return await clientFetcher.delete("/users/me");
      }
    : async (): Promise<void> => {
        console.warn("deleteCurrentUser is disabled in production");
      };
